import { createClient } from '@supabase/supabase-js';

// Create a single shared Supabase client instance
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      storage: localStorage,
      autoRefreshToken: true,
      detectSessionInUrl: false
    }
  }
);

export default supabase;